export const dictionary = {
  fi: {
    "Confirm reservation": "Vahvista varaus",
    "Price from text": "Alkaen",
    "Quantity text": "Kappalemäärä",
    "End reservation text": "Päättyen",
    "Bed space label": "Vuodepaikkaa",
    "Add new label": "Lisää uusi",
    "Pick up accommodation text": "Sisäänkirjautuminen",
    "Return accommodation text": "Uloskirjautuminen",
    "Timepicker start title accommodation": "Sisään kirjautumisaika",
    "Timepicker return title accommodation": "Ulos kirjautumisaika",
    "Suggested new pickup time label":
      "Valitse alta sopiva nouto- ja palautusaika",
    "Suggested new timespan label": "Valitse alta sopiva vuokrauksen aikaväli",
    "Suggested new time accommodation label":
      "Valitse alta sopiva sisäänkirjautumis- ja uloskirjautumisaika",
    "Search update text": "Suorita haku uudelleen, jotta tulokset päivittyvät.",
    "Date label": "Päivämäärä",
    "Timepicker closed error": "Suljettu",
    "Select duration label": "Valitse varauksen kesto",
    "Credit check approval label":
      "Luottotietoni saa tarkistaa. Mikäli luottotietoni eivät ole kunnossa, olen valmis maksamaan 600 € vakuusmaksun joka palautetaan vuokrauksen jälkeen.",
    "Invalid voucher label": "Virheellinen koodi",
    "Invalid phonenumber label": "Virheellinen puhelinnumero",
    "Payment method error": "Valitse maksutapa",
    "Distance service error label": "Valitse korkeintaan yksi",
    "Accept credit check label": "Hyväksy luottotietojen tarkistus",
    "Accept port terms label": "Hyväksy satamaohje",
    "Accept privacy policy label": "Hyväksy tietosuojaseloste",
    "SSN error label":
      "Syötä suomalainen henkilötunnus. Muussa tapauksessa ota yhteys asiakaspalveluun",
    "Accept terms label": "Hyväksy vuokrausehdot",
    "Accept terms error": "Hyväksy vuokrausehdot",
    "Fill this field label": "Täytä tämä kenttä",
    "Check email label": "Tarkista sähköposti",
    "Check phonenumber label": "Tarkista puhelinnumero",
    "Non matching emails label": "Sähköpostit eivät täsmää",
    "Select product label": "Valitse tuote",
    "Select product group label": "Valitse tuoteryhmä",
    "Select company label": "Valitse",
    "Step 1 default label": "Valitse toimipiste",
    "Step 1 custom label": "Valitse tuoteryhmä",
    "Step 2 default label": "Valitse tuote",
    "Step 3 default label": "Lisätarvikkeet",
    "Step 4 default label": "Yhteystiedot",
    "Provider default title": "Nouto- ja palautuspaikka",
    "Provider custom title product": "Tuoteryhmä",
    "Provider custom title service": "Palvelumuoto",
    "Error: No company": "Valitse ensin toimipiste.",
    "Timeframe default title": "Valitse nouto- ja palautusaika.",
    "Timeframe custom title": "Tulo- ja lähtöaika.",
    "Provider default label": "Valitse toimipiste",
    "Provider custom label": "Valitse tuoteryhmä",
    "Select all companies label": "Kaikki toimipisteet",
    "Time error message start time":
      "Lopetusaika ei voi olla ennen aloitusaikaa.",
    "Select pickup date": "Valitse noutopäivä",
    "Select return date": "Valitse palautuspäivä",
    "Select start date": "Valitse aloituspäivä",
    "Select return date": " Valitse lopetuspäivä",
    "Selected company": "Valittu toimipiste",
    "Reservation timeframe selected": "Varauksen päivämäärät on valittu",
    "Reservation fixed timeframe selected": "Varauksen päivämäärä on valittu",
    "Daterange selected label": "Päivämäärä on valittu",
    "Daterange specific times": "TODO",
    "Daterange schedule text": "Valittu ajanjakso",
    "Timepicker starttime title": "Valitse aloitusaika",
    "Timepicker start title": "Aloitusaika",
    "Timepicker return title": "Lopetusaika",
    "Timepicker returntime title": "Valitse palautusaika",
    "DateRange SPECIAL company alert title":
      "Voit halutessasi valita palautuksen seuraavalle päivälle",
    "Cancel text": "Peruuta",
    "Check times label": "Tarkista ajat",
    "Search label": "Hae",
    "Next label": "Seuraava",
    "Daterange select title": " Valitse ajankohta",
    "Daterange dependency missing default label": "Valitse ensin toimipiste",
    "Daterange dependency missing custom label": "Valitse ensin tuoteryhmä",
    "Daterange error: closed": "Olemme suljettu",
    "Daterange allowed start times": "Sallitut noutoajat",
    "Daterange allowed return times": "Sallitut palautusajat",
    "Daterange closing time": "sulkemisaika on ",
    "Daterange opening time": "aukeamisaika on ",
    "Daterange next day time": "Avaamme taas ",
    "Daterange pickup date": "Noutopäivä",
    "Pickup time text": "Noutoaika",
    "Return time text": "Palautusaika",
    "Daterange return date": "Palautuspäivä",
    "Daterange fixed timeframe label": "Valitse varauksen kesto",
    "Mobile date picker start text ": "Valitse varauksen aloituspäivä",
    "Mobile date picker end text ": "Valitse varauksen lopetuspäivä",
    "Mobile datepicker select time": "2. Valitse kellonaika",
    "Mobile datepicker solid time": "2. Valitse varauksen kesto",
    "Search button text": "Aseta",
    "No free times": " Haetulla aikavälillä ei vapaita aikoja.",
    "No available products": "Ei vapaita noutoaikoja lähipäivinä.",
    "Sort options top results": "Osuvimmat",
    "Sort options cheapest results": "Halvimmat",
    "Sort options most expensive results": "Kalleimmat",
    "More results button text": "Näytä lisää tuloksia",
    "Show all categories text": "Kaikki",
    "Show text": "Näytä",
    "Hide text": "Piilota",
    "Filters text": "Suodattimet",
    "Remove filters": "Tyhjennä kaikki",
    "All categories text": "Kaikki",
    "No time match": "Tämän tuotteen lähin aloitusaika",
    "For reservation": "kestävälle varaukselle on ",
    "Or equivalent text": "Tai vastaava, ",
    "product text": "-luokan tuote.",
    "Available text": "vapaana",
    "More information": "Lisätietoja [+]",
    "Reservation calendar": "Katso varaustilanne",
    "Reserve product": "Varaa tuote",
    "Reserved text": "Tuote varattu",
    "Continue order": "Jatka tilausta",
    "Included distance label": "Sisältyvät kilometrit: ",
    "Minimum driving age": "Ajo-ikäraja on ",
    "Years text": " vuotta",
    "Selected products": "Valitut tuotteet",
    "Additional services": "Lisäpalvelut",
    "Total text": "Yhteensä",
    "Shopping cart is empty": "Ostoskorisi on tyhjä",
    "Add products": "Lisää tuotteita",
    "Continue reservation": "Jatka tilausta",
    "Price summary": "Hinnan yhteenveto",
    "Order summary": "Tilauksen yhteenveto",
    "Inc vat": "sis. ALV",
    "Pick up text": "Nouto",
    "Start reservation text": "Alkaen",
    "Return text": "Palautus",
    "Contact information": "Täytä yhteystiedot",
    "Renter is a company": "Vuokraaja on yritys",
    "Company name": "Yrityksen nimi",
    "Business id": "Y-tunnus",
    "Billing address": "Laskutusosoite",
    "Cititation text": "Viitetieto",
    "Name label": "Nimi",
    Firstname: "Etunimi",
    Lastname: "Sukunimi",
    "Social security number": "Henkilötunnus",
    "Address label": "Osoite",
    "City label": "Kaupunki",
    "Postal code label": "Postinumero",
    "Email label": "Sähköposti",
    "Email repeat label": "Sähköposti (uudelleen)",
    "Phone number label": "Puhelin",
    "Country code label": "Suuntanro",
    "Message to dealer": "Terveisiä vuokraamolle",
    "Different driver": "Kuljettaja eri kuin vuokraaja",
    "Different drivers name": "Kuljettajan nimi",
    "Different drivers ssn": "Henkilötunnus",
    "Different drivers address": "Kuljettajan osoite",
    "Different drivers city": "Kuljettajan Kaupunki",
    "Different drivers postal number": "Kuljettajan postinumero",
    "Different drivers phone": "Kuljettajan puhelinnumero",
    "Different drivers email": "Kuljettajan sähköposti",
    "Additional driver": "Lisäkuljettaja",
    "Credit check label": "Luottotietojen tarkistus",
    "Accept text": "Hyväksyn ",
    "RENTAL TERMS": "VUOKRAUSEHDOT",
    "And text": " ja ",
    "Rental agreement": "vuokrasopimuksen",
    "Strong authentication tooltip":
      "   Vahvalla tunnistautumisella hyväksyt vuokraamon vuokrausehdot ja vuokrasopimuksen.",
    Authentication: "Tunnistautuminen",
    "Authentication failed": "Authentication failed",
    "Proceed to authentication": "Jatka tunnistautumaan",
    "Authentication completed": "Tunnistautuminen suoritettu!",
    "Method of payment": "Maksutapa",
    "Authentication completed + signed":
      "Tunnistautuminen suoritettu ja sopimus allekirjoitettu",
    "Voucher label": "Alennuskoodi",
    "Set label": "Aseta",
    "Payment now or upon pick-up": "Maksu nyt vai noudettaessa",
    "Payment now label": "Maksa heti",
    "Not available over": "Ei käytössä yli",
    Reservations: " varauksiin",
    "Pay text": "Maksa",
    "Booking deposit": "varausmaksu nyt, loput viimeistään",
    "Remaining payment": "",
    "Before the start of reservation":
      "päivää ennen varauksen alkua (Visma Pay)",
    "Go to payment": "Siirry maksamaan",
    "Make a reservation": "Varaa",
    "Pay upon pick-up": "Maksa noudettaessa",
    "Deposit text": "Varausmaksu",
    "Amount to be paid": "Maksettavaa",
    "Bank fee": "Verkkopankki",
    "Credit card": "Korttimaksut",
    "Other payment methods": "Muut maksutavat",
    "Pay by invoice": "Maksa laskulla",
    "Online payment not available":
      "Verkkomaksu ei ole mahdollinen, jos varauksen summa on yli ",
    "Contact the dealer": "Ota yhteys vuokraamon, ",
    "Reservation failed text": "varaus ei onnistu.",
    "Something went wrong": "Jokin meni vikaan",
    "Something went wrong 2":
      "Jokin meni vikaan. Ota yhteys vuokraamoon tai yritä uudelleen palaamalla alkuun.",
    "Something went wrong 3":
      "Varauksen tietoja ei voida näyttää, ota tarvittaessa yhteys vuokraamoon",
    "Something went wrong 4":
      "Haettua varausta ei ole olemassa tai se on vanhentunut. Yritä uudelleen palaamalla alkuun, tai ota tarvittaessa yhteys vuokraamoon",
    "Something went wrong 5":
      "Varauksen tietoja ei voi enää muokata, ota tarvittaessa yhteys vuokraamoon.",
    "Failed creating a reservation": "Varauksen tallennus epäonnistui",
    "Loading reservation": " Varauksen tietoja haetaan",
    "Privacy link": "tietosuojaselosteen",
    "Auth no match SSN error":
      "Syötetty henkilötunnus ei vastaa tunnistautumisessa saatua",
    "Payment by invoice text":
      "Mikäli haluat maksaa varauksesi laskulla, valitse alapuolelta maksutavaksi yrityslasku",
    "Port instructions link": "satamaohjeen",
    "Payment completed": "Maksu suoritettu",
    "Payment on pick-up": "Maksu noudettaessa",
    "Complete the payment": "Suorita maksu varauksen viimeistelemiseksi",
    "pcs text": "kpl",
    "Additional services title": "Valitse lisäpalvelusi",
    "Insurance coverage title": "Vakuutusturva",
    "Distance service title": "Ajomatka",
    "Daterange check-in date": "Tulopäivä",
    "Daterange check-out date": "Lähtöpäivä",

    "Daterange check-in time": "Tuloaika",
    "Daterange check-out time": "Lähtöaika",
    "Authentication failed": "Tunnistautuminen epäonnistui",
    "Gnista additional service label":
      "Onko teillä mitään ruokavalioita tai allergioita?",
    "More info label": "Lisätietoja",
    "No finnish ssn": "Minulla ei ole suomalaista henkilötunnusta",
  },
  en: {
    "Confirm reservation": "Confirm reservation",
    "Price from text": "From",
    "Quantity text": "Quantity",
    "End reservation text": "Ending",
    "Start reservation text": "Starting from",
    "Suggested new timespan label": "Select a suitable rental period below.",
    "More info label": "More information",
    "Bed space label": "Sleeping accommodation",
    "Add new label": "Add new",
    "Pick up accommodation text": "Check-in",
    "Return accommodation text": "Check-out",
    "Timepicker start title accommodation": "Check-in time",
    "Timepicker return title accommodation": "Check-out time",
    "Suggested new pickup time label":
      "Choose a suitable pick-up and return time below.",
    "Suggested new time accommodation label":
      "Choose a suitable check-in and check-out time below.",
    "Search update text":
      "Please perform the search again to update the results.",
    "Date label": "Date",
    "Timepicker closed error": "Closed",
    "Select duration label": "Choose the duration of the reservation",
    "Credit check approval label":
      "My credit information may be checked. If my credit information is not in order, I am willing to pay a security deposit of 600 €, which will be refunded after the rental.",
    "Invalid voucher label": "Invalid discount code",
    "Invalid phonenumber label": "Invalid phonenumber",
    "Payment method error": "Select payment method",
    "Distance service error label": "Select at most one",
    "Accept credit check label": "Accept the credit check",
    "Accept port terms label": "Accept the port instructions",
    "Accept privacy policy label": "Accept the privacy policy",
    "SSN error label":
      "Enter a Finnish personal identification number. Otherwise, contact customer service.",
    "Accept terms label": "Accept terms",
    "Accept terms error": "Accept terms",
    "Check email label": "Check email address",
    "Check phonenumber label": "Enter a valid phonenumber",
    "Non matching emails label": "Emails do not match",
    "Fill this field label": "Fill this field",
    "Time error message start time":
      "The return time must not precede the start time",
    "Select product label": "Select product",
    "Select product group label": "Select product group",
    "Select company label": "Select company",
    "Step 1 default label": "Select location",
    "Step 1 custom label": "Select product group",
    "Step 2 default label": "Select product",
    "Step 3 default label": "Additional services",
    "Step 4 default label": "Contact information",
    "Check times label": "Check times",
    "Provider default title": "Rental location",
    "Provider custom title product": "Product group",
    "Provider custom title service": "Serviceform",
    "Error: No company": "First select company.",
    "Timeframe default title": "Select rental timeframe",
    "Timeframe custom title": "Check-in-, Check-out time.",
    "Provider default label": "Select location",
    "Provider custom label": "Select product group",
    "Select all companies label": "All locations",
    "Select pickup date": "Select pickup date",
    "Select return date": "Select return date",
    "Select start date": "Select start date",
    "Select return date": " Select return date",
    "Pickup time text": "Pickup time",
    "Return time text": "Return time",
    "Mobile datepicker select time": "2. Select time",
    "Mobile datepicker solid time": "2. Valitse varauksen kesto",
    "Reservation timeframe selected": "Reservation dates are now selected",
    "Reservation fixed timeframe selected": "Reservation date is selected",
    "Daterange selected label": "Dates selected",
    "Daterange specific times": "TODO",
    "Timepicker starttime title": "Select start time",
    "Timepicker start title": "Start time",
    "Timepicker return title": "Return time",
    "Timepicker returntime title": "Select return time",
    "DateRange SPECIAL company alert title":
      "If desired, you may opt to schedule the return for the following day",
    "Cancel text": "Cancel",

    "Next label": "Next",
    "Search label": "Search",
    "Daterange select title": " Select date",
    "Daterange dependency missing default label": "First select a location",
    "Daterange dependency missing custom label": "First select product group",
    "Daterange error: closed": "We are closed",
    "Daterange allowed start times": "Allowed pickup times are ",
    "Daterange allowed return times": "Allowed return times are ",
    "Daterange fixed timeframe label": "Choose the duration of the reservation",
    "Daterange closing time": "we close at ",
    "Daterange opening time": "we open at ",
    "Daterange next day time": "We are open on ",
    "Daterange pickup date": "Start date",
    "Daterange return date": "Return date",
    "Daterange schedule text": "Schedule for reservation",
    "Selected company": "Selected company",
    "Mobile date picker start text ": "Select the start date",
    "Mobile date picker end text ": "Select the return date",
    "Search button text": "Search",
    "No free times": "No available products in selected timeframe.",
    "No available products": "No available products in selected timeframe.",
    "Sort options top results": "Top results",
    "Sort options cheapest results": "Cheapest",
    "Sort options most expensive results": "Most expensive",
    "More results button text": "Show more results",
    "Show all categories text": "All categories",
    "Show text": "Show",
    "Hide text": "Hide",
    "Filters text": "filters",
    "Remove filters": "Remove all filters",
    "All categories text": "All categories",
    "No time match": "Nearest available start time for booking this product:",
    "For reservation": " ",
    "Or equivalent text": "Or equivalent, ",
    "product text": "product.",
    "pcs text": "pcs",
    "Available text": "available",
    "More information": "View details [+]",
    "Reservation calendar": "Check availability",
    "Reserve product": "Reserve product",
    "Reserved text": "Reserved",
    "Continue order": "Continue order",
    "Included distance label": "Included distance: ",
    "Minimum driving age": "Minimum driving age is ",
    "Years text": " years",
    "Selected products": "Selected products",
    "Additional services": "Additional services",
    "Total text": "Total",
    "Shopping cart is empty": "Shopping cart is empty.",
    "Add products": "Add products",
    "Continue reservation": "Continue",
    "Price summary": "Price summary",
    "Order summary": "Order summary",
    "Inc vat": "Inc VAT",
    "Pick up text": "Pick up",
    "Return text": "Return",
    "Contact information": "Contact information",
    "Renter is a company": "Renter is a company",
    "Company name": "Company name",
    "Business id": "Business id",
    "Billing address": "Laskutusosoite",
    "Cititation text": "Cititation",
    "Name label": "Name",
    Firstname: "First name",
    Lastname: "Last name",
    "Social security number": "Social security number",
    "Address label": "Address",
    "City label": "City",
    "Postal code label": "Postal code",
    "Email label": "Email",
    "Email repeat label": "Email (again)",
    "Phone number label": "Phone number",
    "Country code label": "Country code",
    "Message to dealer": "Message to rental",
    "Different driver": "Different driver",
    "Different drivers name": "Drivers name",
    "Different drivers ssn": "Drivers SSN",
    "Different drivers address": "Drivers address",
    "Different drivers city": "Drivers City",
    "Different drivers postal number": "Drivers postal number",
    "Different drivers phone": "Drivers Phone number",
    "Different drivers email": "Drivers Email",
    "Additional driver": "Additional driver",
    "Credit check label": "Credit rating check",
    "Accept text": "I accept the ",
    "RENTAL TERMS": "RENTAL TERMS",
    "And text": " and the ",
    "Rental agreement": "rental agreement",
    "Strong authentication tooltip":
      "By strong authentication, you accept the rental terms and rental agreement of the rental company.",
    Authentication: "Authentication",
    "Authentication failed": "Authentication failed",
    "Proceed to authentication": "Proceed to authentication",
    "Authentication completed": "Authentication completed",
    "Method of payment": "Method of payment",
    "Authentication completed + signed":
      "Authentication completed and contract has been signed",
    "Voucher label": "Discount code",
    "Set label": "Set",
    "Payment now or upon pick-up": "Payment now or upon pick-up",
    "Payment now label": "Payment now",
    "Not available over": "Not available over ",
    Reservations: " reservations",
    "Pay text": "Pay now ",
    "Booking deposit": " booking deposit, ",
    "Remaining payment": "and the remaining amount no later than",
    "Before the start of reservation":
      "day before the start of the reservation (Visma Pay)",
    "Go to payment": "Go to payment",
    "Contact the dealer": "Please contact the rental company, ",
    "Make a reservation": "Make a reservation",
    "Pay upon pick-up": "Pay upon pick-up",
    "Deposit text": "Deposit",
    "Amount to be paid": "Amount to be paid",
    "Bank fee": "Bank",
    "Credit card": "Credit cards",
    "Other payment methods": "Other payment methods",
    "Pay by invoice": "Pay by invoice",
    "Online payment not available":
      "Online payment is not possible if the total amount of the reservation exceeds",
    "Something went wrong": "Something went wrong",
    "Something went wrong 2":
      "Something went wrong, contact the dealer or try again",
    "Something went wrong 3":
      "Reservation information cannot be shown, contact the dealer if necessary",
    "Something went wrong 4":
      "The requested reservation does not exist or has expired. Try again or contact the dealer if necessary",
    "Something went wrong 5":
      "Reservaiton info unavailable, contact the dealer if necessary",
    "Failed creating a reservation": "Failed to create a reservation",
    "Loading reservation": " Loading reservation",
    "Auth no match SSN error":
      "The entered social security number does not match the one received during authentication",
    "Privacy link": "privacy policy statement",
    "Payment by invoice text":
      "If you wish to pay your reservation by invoice, select 'company invoice' as the payment method below",
    "Port instructions link": "port instructions",
    "Payment completed": "Payment completed",
    "Payment on pick-up": "Payment on pick-up",
    "Complete the payment": "Complete the payment to finalize the reservation",
    "Additional services title": "Select additional services",
    "Insurance coverage title": "Insurance coverage",
    "Distance service title": "Distance service",
    "Daterange check-in date": "Check-in",
    "Daterange check-out date": "Check-out",
    "Daterange check-in time": "Check-in",
    "Daterange check-out time": "Check-out",
    "Authentication failed": "Authentication failed",
    "Gnista breakfest service description": "Breakfast",
    "Gnista number of guests service description": "Number of guests",
    "Reservation failed text": "reservation failed.",
    "Gnista additional service label": "Do you have any diets or allergies?",
    "No finnish ssn": "I do not have a Finnish social security number",
  },

  se: {
    "Confirm reservation": "Bekräft a bokning",
    "Price from text": "Från",
    "Quantity text": "Antal",
    "End reservation text": "Slutande",
    "Start reservation text": "Från",
    "Suggested new timespan label": "Välj en lämplig uthyrningsperiod nedan.",
    "More info label": "Mer information",
    "Gnista additional service label": "Har ni några dieter eller allergier?",
    "Bed space label": "Sovplatser",
    "Add new label": "Lägg till ny",
    "Pick up accommodation text": "Incheckning",
    "Return accommodation text": "Utcheckning",
    "Timepicker start title accommodation": "Incheckningstid",
    "Timepicker return title accommodation": "Utcheckningstid",
    "Suggested new pickup time label":
      "Välj lämplig hämtning och återlämningstid nedan.",
    "Suggested new time accommodation label":
      "Välj lämplig inchecknings- och utcheckningstid nedan.",
    "Search update text":
      "Vänligen utför sökningen igen för att uppdatera resultaten.",
    "Date label": "Datum",
    "Daterange error: closed": "Vi är stängda",
    "Timepicker closed error": "Stängt",
    "Select duration label": "Välj bokningens längd",
    "Credit check approval label":
      "Min kreditinformation kan komma att kontrolleras. Om min kreditinformation inte är i ordning, är jag villig att betala en säkerhetsdeposition på 600 €, vilken kommer att återbetalas efter hyresperiodens slut.",
    "Invalid voucher label": "Ogiltig rabattkod",
    "Invalid phonenumber label": "Ogiltig telefonnummer",
    "Payment method error": "Välj betalningsmetod",
    "Distance service error label": "Välj högst en",
    "Accept credit check label": "Godkänn kreditupplysningen",
    "Accept port terms label": "Godkänn hamninstruktionerna",
    "Accept privacy policy label": "Godkänn integritetspolicyn",
    "SSN error label": "Ange finskt personnummer. Annars kontakta kundtjänst.",
    "Accept terms label": "Jag accepterar hyresvillkoren",
    "Accept terms error": "Vänligen acceptera hyresvillkoren",
    "Check email label": "Kontrollera e-postadressen",
    "Check phonenumber label": "Ange ett giltigt telefonnummer",
    "Non matching emails label": "E-postmeddelanden matchar inte",
    "Fill this field label": "Fyll i detta fält",
    "Time error message start time": "Returtiden får inte föregå starttiden.",
    "Select product label": "Välj produkt",
    "Select company label": "Välj företag",
    "Select product group label": "Välj produktgrupp",
    "Accept text": "Jag accepterar ",
    "Add products": "Lägg till produkter ",
    "Additional driver": " Ytterligare förare",
    "Additional services": " Ytterligare tjänster",
    "Address label": "Adress",
    "All categories text": "Alla kategorier",
    "Amount to be paid": "Belopp att betala",
    "And text": " och ",
    "Auth no match SSN error":
      "Det angivna personnumret stämmer inte överens med det som mottogs under autentiseringen",
    "Authentication completed + signed":
      "Autentiseringen är slutförd och kontraktet har undertecknats",
    "Authentication completed": "Autentiseringen är slutförd",
    "Authentication failed": "Autentiseringen misslyckades",
    "Available text": "tillgänglig",
    "Bank fee": "Nätbank",
    "Credit card": "Kreditkort",
    "Before the start of reservation":
      "dagen innan bokningens start (Visma Pay)",
    "Billing address": "Faktureringsadress",
    "Booking deposit": "Bokningsavgift",
    "Business id": "Företags-id",
    "Cancel text": "Avbryt",
    "Cititation text": "Erinran",
    "City label": "Stad",
    "Company name": "Företagsnamn",
    "Complete the payment": "Slutför betalningen för att slutföra bokningen",
    "Contact information": "Kontaktinformation",
    "Contact the dealer": "Vänligen kontakta uthyrningsföretaget,",
    "Continue order": "Fortsätt beställning",
    "Continue reservation": "Fortsätt",
    "Credit card": "Kreditkort",
    "Credit check label": "Kreditbedömning",
    "Daterange allowed return times": "Tillåtna returtider är",
    "Daterange allowed start times": "Tillåtna hämtningstider är",
    "Daterange closing time": "vi stänger kl.",
    "Daterange dependency missing custom label": "Välj först produktgrupp",
    "Daterange dependency missing default label": "Välj först en plats",
    "Daterange error  closed": "Vi är stängda",
    "Daterange fixed timeframe label": "Välj varaktighet för bokningen",
    "Daterange next day time": "Vi är öppna på",
    "Daterange opening time": "vi öppnar kl.",
    "Daterange pickup date": "Startdatum",
    "Daterange return date": "Returdatum",
    "Daterange schedule text": "Schema för bokning",
    "Daterange select title": "Välj datum",
    "Daterange selected label": "Valda datum",
    "DateRange SPECIAL company alert title":
      "Om du önskar kan du schemalägga returen till följande dag",
    "Daterange specific times": "TODO",
    "Deposit text": "Deposition",
    "Different driver": "Annat förarnamn",
    "Different drivers address": "Förarens adress",
    "Different drivers city": "Förarens stad",
    "Different drivers email": "Förarens e-post",
    "Different drivers name": "Förarens namn",
    "Different drivers phone": "Förarens telefonnummer",
    "Different drivers postal number": "Förarens postnummer",
    "Different drivers ssn": "Förarens personnummer",
    "Email label": "E-post",
    "Email repeat label": "E-post (åter)",
    "Error  No company": "Välj först företag.",
    "Failed creating a reservation": "Misslyckades med att skapa en bokning",
    "Filters text": "filter",
    "For reservation": "",
    "Go to payment": "Gå till betalning",
    "Hide text": "Dölj",
    "Inc vat": "Inkl. moms",
    "Included distance label": "Inkluderad körsträcka",
    "Loading reservation": "Laddar bokning",
    "Make a reservation": "Gör en bokning",
    "Message to dealer": "Vill du fråga eller tillägga något?",
    "Method of payment": "Betalningsmetod",
    "Minimum driving age": "Minsta köråldern är",
    "Mobile date picker end text ": "Välj returdatum",
    "Mobile date picker start text ": "Välj startdatum",
    "Mobile datepicker select time": "2. Välj tid",
    "Mobile datepicker solid time": "2. Valitse varauksen kesto",
    "Other payment methods": "Övriga betaltjänster",
    "More information": "Visa detaljer [+]",
    "More results button text": "Visa fler resultat",
    "Name label": "Namn",
    Firstname: "Förnamn",
    Lastname: "Efternamn",
    "Check times label": "Kontrollera tider",
    "Next label": "Nästa",
    "No available products":
      "Inga tillgängliga produkter i valt tidsintervall.",
    "No free times": "Inga tillgängliga produkter i valt tidsintervall.",
    "No time match":
      "Närmaste tillgängliga starttid för att boka den här produkten",
    "Not available over": "Ej tillgängligt över",
    "Online payment not available":
      "Onlinebetalning är inte möjligt om det totala beloppet för bokningen överstiger",
    "Or equivalent text": "Eller motsvarande,",
    "Order summary": "Orderöversikt",
    "Pay by invoice": "Betalning via faktura",
    "Pay text": "Betal nu,",
    "Pay upon pick-up": "Betalning vid hämtning",
    "Payment by invoice text":
      "Om du vill betala din bokning via faktura väljer du företagsfaktura som betalningsmetod nedan,",
    "Payment completed": "Betalning slutförd",
    "Payment now label": "Betalning nu",
    "Payment now or upon pick-up": "Betalning nu eller vid upphämtning",
    "Payment on pick-up": "Betalning vid upphämtning",
    "pcs text": "st",
    "Phone number label": "Telefonnummer",
    "Country code label": "Landsnummer",
    "Pick up text": "Hämtning",
    "Pickup time text": "Hämtningstid",
    "Port instructions link": "hamninstruktioner",
    "Postal code label": "Postnummer",
    "Price summary": "Prisöversikt",
    "Privacy link": "Sekretesspolicy",
    "Proceed to authentication": "Gå vidare till autentisering",
    "product text": "produkt.",
    "Provider custom label": "Välj produktgrupp",
    "Provider custom title product": "Produktgrupp",
    "Provider custom title service": "Typ av tjänst",
    "Provider default label": "Välj plats",
    "Provider default title": "Uthyrningsplats",
    "Remaining payment": "och återstående belopp senast",
    "Remove filters": "Ta bort alla filter",
    "Rental agreement": "hyresavtal",
    "RENTAL TERMS": "hyresvillkoren",
    "Renter is a company": "Hyrestagaren är ett företag",
    "Reservation calendar": "Kontrollera tillgänglighet",
    "Reservation timeframe selected": "Reservationsdatumen är nu valda",
    "Reservation fixed timeframe selected": "Reservationsdatumen är nu valda",
    "Reserve product": "Boka produkt",
    "Reserved text": "Reserverat",
    "Return text": "Retur",
    "Return time text": "Returtid",
    "Search button text": "Sök",
    "Search label": "Sök",
    "Select all companies label": "Alla platser",
    "Select pickup date": "Välj upphämtningsdatum",
    "Select return date": "Välj återlämningsdatum",
    "Select return date": "Välj återlämningsdatum",
    "Select start date": "Välj startdatum",
    "Selected company": "Valt företag",
    "Selected products": "Valda produkter",
    "Set label": "Ställ in",
    "Shopping cart is empty": "Varukorg är tom.",
    "Show all categories text": "Alla kategorier",
    "Show text": "Visa",
    "Social security number": "Personnummer",
    "Something went wrong": "Något gick fel",
    "Something went wrong 2":
      "Något gick fel. Kontakta uthyrningsfirman eller försök igen genom att gå tillbaka till början.",
    "Something went wrong 3":
      "Det går inte att stänga bokningen, ta vid behov tetnis för dagen",
    "Something went wrong 4":
      "Den begärda reservationen finns inte eller har löpt ut. Försök igen genom att gå tillbaka till början, eller kontakta uthyrningsfirman vid behov",
    "Something went wrong 5":
      "Bokningsuppgifterna kan inte visas, kontakta uthyrningsstället vid behov.",
    "Sort options cheapest results": "Billigast",
    "Sort options most expensive results": "Dyrast",
    "Sort options top results": "Toppresultat",
    "Step 1 custom label": "Välj produktgrupp",
    "Step 1 default label": "Välj plats",
    "Step 2 default label": "Välj produkt",
    "Step 3 default label": "Tilläggstjänster",
    "Step 4 default label": "Kontaktinformation",
    "Strong authentication tooltip":
      "Genom stark autentisering accepterar du hyresvillkoren och hyresavtalet för uthyrningsföretaget.",
    "Timeframe custom title": "Inchecknings- och utcheckningstid.",
    "Timeframe default title": "Välj hyrestidsram",
    "Timepicker return title": "Returtid",
    "Timepicker returntime title": "Välj returtid",
    "Timepicker start title": "Starttid",
    "Timepicker starttime title": "Välj starttid",
    "Total text": "Totalt",
    "Voucher label": "Rabattkod",
    "Years text": " år",
    Authentication: "Autentisering",
    Reservations: "Reservationer",
    "Additional services title": "Välj ytterligare tjänster",
    "Insurance coverage title": "Försäkringsskydd",
    "Distance service title": "Körsträcka",
    "Daterange check-in date": "Incheckning",
    "Daterange check-out date": "Utcheckning",
    "Daterange check-in time": "Incheckning",
    "Daterange check-out time": "Utcheckning",
    "Authentication failed": "Identifiering/autentisering misslyckades",
    "Gnista breakfest service description": "Frukost",
    "Gnista number of guests service description": "Antal gäster",
    "Reservation failed text": "bokningen kan inte göras.",
    "No finnish ssn": "Jag har inte ett finskt personnummer",
  },
};

export const translation = {
  get: (language, target) => dictionary[language][target],
};
